/**
 * Utility functions for consistent error handling across the application
 */

/**
 * Extracts error message from various API response formats
 * @param {Object} data - The response data object
 * @returns {string} - The extracted error message or a default message
 */
export const extractErrorMessage = (data) => {
  if (!data) {
    return "An unexpected error occurred";
  }

  // Try to extract from common error fields
  if (data.responseText && typeof data.responseText === 'string') {
    return data.responseText;
  }

  if (data.message && typeof data.message === 'string') {
    return data.message;
  }

  if (data.error && typeof data.error === 'string') {
    return data.error;
  }

  // For objects, try to stringify safely
  if (typeof data === 'object') {
    try {
      // Don't expose full object, just return generic message
      return "An error occurred while processing your request";
    } catch (e) {
      return "An unexpected error occurred";
    }
  }

  // For string data, return as is
  if (typeof data === 'string') {
    return data;
  }

  return "An unexpected error occurred";
};

/**
 * Authentication-specific error messages
 */
export const AUTH_ERRORS = {
  INVALID_RESPONSE: "Unable to connect to server. Please try again.",
  MISSING_AUTH_DATA: "Authentication failed. Please check your credentials.",
  INVALID_CREDENTIALS: "Invalid username or password",
  PROFILE_FETCH_FAILED: "Unable to retrieve user profile. Please try again.",
  ACCOUNT_STATUS_FAILED: "Unable to retrieve account information",
  SESSION_EXPIRED: "Your session has expired. Please login again.",
  INSUFFICIENT_PERMISSIONS: "You do not have permission to access this application",
};
